<div class="top-bar-right top-bar-icons">
  <div class="" global-search></div>
  <div *ngIf="basicPlanLimit?.basicRestrictionsActive" class="basic-plan-usage">
    <span class="basic-plan-counter"
          tabindex="0"
          role="button"
          (click)="showBasicPlanUsage()"
          (keydown.enter)="showBasicPlanUsage()"
          (keydown.space)="showBasicPlanUsage(); $event.preventDefault()"
          [attr.aria-label]="'Basic subscription: ' + basicPlanLimit.used + ' of ' + basicPlanLimit.limit + ' plans for ' + basicPlanLimit.taxYear"
          title="Your Basic subscription plan usage">
      Basic · {{basicPlanLimit.used}} / {{basicPlanLimit.limit}} plans · {{basicPlanLimit.taxYear}}
    </span>
    <button type="button" class="basic-plan-upgrade" (click)="requestBasicPlanUpgrade()">
      Upgrade
    </button>
  </div>
  <button *ngIf="basicPlanLimitUnavailable" type="button" class="basic-plan-counter"
          (click)="retryBasicPlanLimit()" title="Retry loading Basic subscription plan usage">
    Basic plan usage unavailable · Retry
  </button>
  <ng-template [ngIf]="onboardStatus === 'Done'">
    <span class="pointer firm-option badge-tooltip" *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'">
    <i class="icon ion-cube" (click)="showPage('tax-planning/manage-firms')"></i>
    <span class="bottomTooltiptext">Firms</span>
  </span>
    <span class="pointer firm-option badge-tooltip" *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'">
    <i class="icon ion-document-text" (click)="showPage('tax-planning/reports')"></i>
    <span class="bottomTooltiptext">Reports</span>
  </span>
    <span class="badge-tooltip">
    <i class="ion-android-settings" style="margin-right: 25px;" data-toggle="apps-dropdown-id" (click)="openAppsMenu($event)" foundation ></i>
    <span class="bottomTooltiptext">SETTINGS</span>
  </span>
  </ng-template>

  <div class="logout-profile-badge" data-toggle="logout-menu-dropdown-id" (click)="openLogoutMenu($event)" foundation>
    <div class="logout-badge" *ngIf="user.thumbnail && user.thumbnail.length > 0">
      <div style="cursor: pointer;border-radius: 50%; width: 27px; height: 27px;position: absolute;"  [ngStyle]="{'background': 'url(' + user.thumbnail + ') center center no-repeat', 'background-size': 'cover'}"></div>
    </div>
    <div class="name-badge" [hidden]="user.thumbnail" style="cursor: pointer;font-weight: bold;" [style.background-color]="user.colorCode">{{getUserBadgeName(user)}}</div>
  </div>
</div>

<div *ngIf="showReconnecting" class="success callout update-bars" data-closable="slide-out-right" [ngClass]="isSideMenuExpanded? '': 'add-left-margin'">
  <div>Reconnecting...</div>
</div>

<div #tpiq  style="font-family: Poppins-Regular;" class="dropdown-pane bottom export-dropdown logout-menu-dropdown" id="logout-menu-dropdown-id" [ngClass]="{'logout-menu-height': !user.thumbnail}" data-dropdown data-hover="false" data-hover-pane="false" foundation>
  <div class="text-align-center" style="padding-top: 15px !important;padding-bottom: 0 !important;" *ngIf="user.thumbnail && user.thumbnail.length > 0">
    <div style="cursor: pointer;border-radius: 50%; width: 60px; height: 60px;display: inline-table"  [ngStyle]="{'background': 'url(' + user.thumbnail + ') center center no-repeat', 'background-size': 'cover'}" (click)="showProfile()"></div>
  </div>
  <div *ngIf="user.thumbnail && user.thumbnail.length > 0" class="text-align-center title" style="padding-top: 0 !important;margin: 0 !important;">
    <span style="text-transform: capitalize;font-size: 14px;color: #707070;position: relative;bottom: 3px">{{user.first_name}} {{user.last_name}}</span>
  </div>
  <div class="text-align-center" [hidden]="user.thumbnail" style="padding-top: 20px !important;padding-bottom: 0 !important;">
    <span class="name-badge" style="cursor: pointer;font-weight: bold; padding: 11px !important;font-size: 16px !important;" [style.background-color]="user.colorCode" (click)="showProfile()">{{getUserBadgeName(user)}}</span>
    <div class="text-align-center title" style="padding-top: 10px !important;margin: 0 !important;">
      <span style="text-transform: capitalize;font-size: 14px;color: #707070;position: relative;bottom: 3px">{{user.first_name}} {{user.last_name}}</span>
    </div>
  </div>
  <div class="export-option" (click)="showProfile()">
    <i class="icon ion-person power-symbol"></i>
    <span>Profile</span>
  </div>
  <hr style="margin: 5px 0 5px 0;"/>
  <div class="export-option" (click)="logout()">
    <i class="icon ion-log-out power-symbol" style="margin-right: 3px !important;"></i>
    <span>Sign Out</span>
  </div>
  <hr style="margin: 5px 0 5px 0;"/>
</div>


<div #apps  style="font-family: Poppins-Regular;" class="dropdown-pane apps-menu-dropdown" id="apps-dropdown-id" data-dropdown data-hover="false" data-hover-pane="false" foundation>
  <div class="close-button"><i class="material-icons timer-icon" (click)="toggleApps()">close</i></div>
  <div class="row apps">

    <div class="column large-6 medium-6 small-6 app" (click)="manageSubscription()">
      <i class="icon ion-card"></i>
      <span class="desc">MANAGE<br>SUBSCRIPTION</span>
    </div>
    <div class="column large-6 medium-6 small-6 app" (click)="manageLogo()">
      <i class="icon ion-image"></i>
      <span class="desc">MANAGE LOGO</span>
    </div>
    <div class="column large-6 medium-6 small-6 app" (click)="manageUsers()">
      <i class="icon ion-ios-people"></i>
      <span class="desc">MANAGE USERS</span>
    </div>
    <div class="column large-6 medium-6 small-6 app" (click)="manageQuestionnaire()" *ngIf="subscriptionStatus == 'Paid'">
      <i class="icon ion-android-list"></i>
      <span class="desc">QUESTIONNAIRE</span>
    </div>
    <!-- <div class="column large-6 medium-6 small-6 app" (click)="manageIntegrations()">
      <i class="icon ion-grid"></i>
      <span class="desc">INTEGRATIONS</span>
    </div> -->
    <div class="column large-6 medium-6 small-6 app" (click)="manageAgreements()">
      <i class="icon ion-document-text"></i>
      <span class="desc">AGREEMENTS</span>
    </div>
  </div>
</div>
